// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAllowContributionsAfterAccountClosureDaysPropertyDto
 */
export interface IAllowContributionsAfterAccountClosureDaysPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IAllowContributionsAfterAccountClosureDaysPropertyDto
     */
    allow_contributions_after_account_closure_days?: number;
    /**
     * 
     * @type {string}
     * @memberof IAllowContributionsAfterAccountClosureDaysPropertyDto
     */
    allow_contributions_after_account_closure_days_state?: IAllowContributionsAfterAccountClosureDaysPropertyDtoAllowContributionsAfterAccountClosureDaysStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAllowContributionsAfterAccountClosureDaysPropertyDtoAllowContributionsAfterAccountClosureDaysStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IAllowContributionsAfterAccountClosureDaysPropertyDto interface.
 */
export function instanceOfIAllowContributionsAfterAccountClosureDaysPropertyDto(value: object): value is IAllowContributionsAfterAccountClosureDaysPropertyDto {
    return true;
}

export function IAllowContributionsAfterAccountClosureDaysPropertyDtoFromJSON(json: any): IAllowContributionsAfterAccountClosureDaysPropertyDto {
    return IAllowContributionsAfterAccountClosureDaysPropertyDtoFromJSONTyped(json, false);
}

export function IAllowContributionsAfterAccountClosureDaysPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAllowContributionsAfterAccountClosureDaysPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'allow_contributions_after_account_closure_days': json['allow_contributions_after_account_closure_days'] == null ? undefined : json['allow_contributions_after_account_closure_days'],
        'allow_contributions_after_account_closure_days_state': json['allow_contributions_after_account_closure_days_state'] == null ? undefined : json['allow_contributions_after_account_closure_days_state'],
    };
}

export function IAllowContributionsAfterAccountClosureDaysPropertyDtoToJSON(json: any): IAllowContributionsAfterAccountClosureDaysPropertyDto {
    return IAllowContributionsAfterAccountClosureDaysPropertyDtoToJSONTyped(json, false);
}

export function IAllowContributionsAfterAccountClosureDaysPropertyDtoToJSONTyped(value?: IAllowContributionsAfterAccountClosureDaysPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allow_contributions_after_account_closure_days': value['allow_contributions_after_account_closure_days'],
        'allow_contributions_after_account_closure_days_state': value['allow_contributions_after_account_closure_days_state'],
    };
}

